import { FiltroRelatorioUnidades } from "core/features/relatorios/typings/index";
import { useCallback, useState } from "react";

export const defaultFiltroRelatorioReservas: FiltroRelatorioUnidades = {
  search: "",
  gruposUnidadesIds: [],
};

function useFiltroRelatorioUnidades() {
  const [filtro, setFiltro] = useState<FiltroRelatorioUnidades>(
    defaultFiltroRelatorioReservas
  );

  const onChangeFiltro = useCallback(
    (newValues: Partial<FiltroRelatorioUnidades>) => {
      setFiltro((prev: any) => ({ ...prev, ...newValues }));
    },
    []
  );

  const onResetFiltro = useCallback(() => {
    setFiltro(defaultFiltroRelatorioReservas);
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroRelatorioUnidades;
